

import Vue from 'vue'

Vue.filter('inputClassErro', function(erro){
	return  erro ? 'form-group has-error has-feedback' :  'form-group has-feedback'
})

Vue.filter('inputGroupClassErro', function(erro){
	return  erro ? 'input-group has-error has-feedback' :  'input-group has-feedback'
})



// WEBPACK FOOTER //
// ./resources/assets/js/filters/forms.js